/**
 * types operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    REST_CALL_LIST_TYPES,
    REST_SERVER_BASE_URL
} from "../config";
import {showError} from "./message";
import {loadTypeDefinitionsSuccessAction} from "../redux/types/actions";
import {fetchJSONActivity} from "./communication";


export function loadTypeDefinitions() {

    return async (dispatch, getState) => {

        try {
            // do server communication
            const { authorization } = getState();
            const typeDefinitions = await fetchJSONActivity(dispatch, "loading types",
                REST_SERVER_BASE_URL + REST_CALL_LIST_TYPES.path, {
                    method: REST_CALL_LIST_TYPES.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            // handle response
            console.log("object type definitions:", typeDefinitions);
            dispatch(loadTypeDefinitionsSuccessAction(typeDefinitions));
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}